let ProductUniqueSky = {
  init: function () {
    this.inputDateMask();
    this.inputHourMask();
    this.changeSections();
    this.modalTriggers();
    this.formatSelect();
    this.changeFormat();
    this.colorSelect();
    this.changeMaskAndBgColor();
    this.changeMapColor();
    this.sizeSelect();
    this.liveInput();
    this.inputCounter();
    this.changeTextColor();
    this.mountInitialMap();
    this.getDataToMountClientMap();
    this.placeInputAutocomplete();
    // this.updateProductPrice();
    this.buyProduct();
    // this.hideBuyButtonOnFocus();
    this.handleDateInput();
    this.updateInputValue();
    this.updateTextButton();
    this.updateClassFocus();
    this.updateFocusElement();
    this.focusFirstTabInput();

  },
  
  inputDateMask: function () {
    const updateTrigger = document.querySelector('.product-right-section__row-search');
    const inputEl = document.querySelector('.product-right-section__date');
    // $.datepicker.setDefaults(
    //   $.extend(
    //     { 'dateFormat': 'dd/mm/yy' },
    //     $.datepicker.regional['nl']
    //   )
    // );
    // $('.product-right-section__date').datepicker({ 
    //   defaultDate: new Date(),
    //   onSelect: function(dateText) {
    //     ProductUniqueSky.setDefaultText(true);
    //   }
    // }).attr("readonly", "readonly");

    inputEl.addEventListener('keyup', () => {

      this.mascara(inputEl, this.maskDate)
    })

  },

  mascara(o, f) {
    let v_obj = o
    let v_fun = f
    setTimeout(function () {
      v_obj.value = v_fun(v_obj.value)
    }, 1)
  },

  maskDate(v) {
    v = v.replace(/\D/g, "");
    v = v.replace(/(\d{2})(\d)/, "$1/$2");
    v = v.replace(/(\d{2})(\d)/, "$1/$2");
    v = v.replace(/(\d{2})(\d{2})$/, "$1$2");
    v = v.slice(0, 10)
    return v;
  },

  handleDateInput: function () {
    const self = this;
    const dateInput = document.getElementById('date');
    dateInput.addEventListener('change', function () {
      self.validadeDate(this)
    });
  },

  validadeDate: function (target) {
    console.log(target)
    if (!target.value) return;
    let { value } = target;
    let day = value.split('/')[0];
    let month = value.split('/')[1];
    let year = value.split('/')[2];
    let currentDate = new Date(`${month}/${day}/${year}`);

    const updateTrigger = document.querySelector('.product-right-section__row-search');

    if (isNaN(currentDate.getTime())) {
      target.value = '';
      alert('Data inválida');
      target.focus();

      return;
    }

    updateTrigger.click();
    setTimeout(function () {
      ProductUniqueSky.setDefaultText(true);
    }, 500)

  },


  removeUnlessCharacters: function (item) {
    console.log(item.value)


    const regex = "1%234567890qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNMáÁãÃàÀâÂäÄéÉèÈêÊëËíÍìÌîÎïÏóÓõÕòÒôÔöÖúÚùÙûÛüÜçÇ,~˜°.!?;:'“‘ \"$-+{}[]()_=@#^&<>/\n\r";
    let { value } = item;
    let newVal = value;

    for (var i = 0; i < value.length; i++) {
      if (!regex.includes(value.charAt(i))) {
        while (newVal.split(value.charAt(i)).length - 1 >= 1) {
          newVal = newVal.replace(value.charAt(i), "");
          item.parentNode.dataset.invalid = `${value.charAt(i)} é um caracter inválido`;
        }
        item.parentNode.classList.add("error-input");
      }
    }

    item.value = newVal;
  },

  updateInputValue: function () {
    const inputElements = document.querySelectorAll('.product > form input');
    inputElements.forEach(item => {
      console.log(item)

      item.addEventListener('keyup', function () {
        ProductUniqueSky.removeUnlessCharacters(item);
      })

      item.addEventListener('blur', function () {
        ProductUniqueSky.removeUnlessCharacters(item);
      })
    })
  },
  updateTextButton: function () {
    const lastTabActive = document.querySelector('.product-right-header__button:last-of-type').classList.contains('button-active');
    const nextButton = document.querySelector('.product-right__button-next');
    const submitButton = document.querySelector('.product-form__cart-submit');

    if (lastTabActive) {
      nextButton.innerText = 'Finalizar';
      nextButton.style.display = 'none';
      submitButton.style.display = 'block';
    } else {
      nextButton.innerText = 'Próximo';
      nextButton.style.display = 'block';
      submitButton.style.display = 'none';
    }

  },

  updateClassFocus: function () {
    const tabIndexElements = document.querySelectorAll('[tabindex]');
    tabIndexElements.forEach(item => {
      item.addEventListener('focus', () => {
        document.querySelector('.-focus')?.classList.remove('-focus');
        item.classList.add('-focus');
      })
    })
  },
  updateFocusElement: function () {
    const focusElement = document.querySelector('.-focus');
    if (focusElement) {
      const focusIndex = focusElement?.tabIndex + 1;
      document.querySelector(`[tabindex="${focusIndex}"]`).focus();

    } else {
      document.querySelector(`[tabindex="1"]`).focus();
    }
  },
  focusFirstTabInput: function () {
    document.querySelector('.-focus')?.classList.remove('.-focus');
    const tabActiveId = document.querySelector('.product-right-header__button.button-active').getAttribute('id');
    const sectionElementActive = document.querySelector(`#${tabActiveId}.product-right-section [tabindex]`);
    console.log(sectionElementActive);
    sectionElementActive.focus();
  },


  inputHourMask: function () {
    const hour = document.querySelector("#hour");
    const minute = document.querySelector("#minute");
    const updateTrigger = document.querySelector('.product-right-section__row-search');

    hour.addEventListener("keypress", function (e) {
      if (e.keyCode < 47 || e.keyCode > 57) {
        e.preventDefault();
      }
    })

    minute.addEventListener("keypress", function (e) {
      if (e.keyCode < 47 || e.keyCode > 57) {
        e.preventDefault();
      }
    })

    hour.addEventListener("keyup", function (e) {
      let val = this.value

      if (val.split('')[0] > 2) {
        this.value = ''
      }

      if (val.split('')[1] > 9) {
        this.value = ''
      }

      if (val > 23) {
        this.value = ''
      }
    })

    hour.addEventListener("change", function (e) {
      updateTrigger.click();
    })

    minute.addEventListener("change", function (e) {
      updateTrigger.click();
    })

    minute.addEventListener("keyup", function () {
      let val = this.value

      if (val.split('')[0] > 5) {
        this.value = ''
      }
    })

  },

  modalTriggers: function () {
    const skyModal = document.querySelector('.sky-modal');
    const modalUpdate = document.querySelector('.sky-update');
    const modalProceed = document.querySelector('.sky-proceed');
    const updateTrigger = document.querySelector('.product-right-section__row-search');
    const proceedTrigger = document.querySelector('#sec-2');

    modalUpdate.addEventListener('click', function () {
      updateTrigger.click();
      skyModal.style.display = 'none';
    })

    modalProceed.addEventListener('click', function () {
      window.locationProceed = true;
      proceedTrigger.click();
      skyModal.style.display = 'none';
    })

  },

  changeSections: function () {
    const headerButtons = document.querySelectorAll(".product-right-header__button");
    const productSections = document.querySelectorAll(".product-right-section");
    const firstStepActive = document.querySelector('#sec-1.button-active');
    const locationInput = document.querySelector('.product-right-section__local');

    locationInput.addEventListener('keyup', function () {
      window.locationProceed = false;
    })

    for (const headerButtonsHandle of headerButtons) {
      headerButtonsHandle.addEventListener("click", function (e) {

        if (firstStepActive && (window.currentLocation !== locationInput.value) && !window.locationProceed) {
          document.querySelector('.sky-modal').style.display = 'flex';
          return;
        }

        for (const productSectionsHandle of productSections) {
          if (e.target.id === productSectionsHandle.id) {
            if (e.target.classList.contains("button-active")) return;

            for (const buttonHandleRemove of headerButtons) {
              buttonHandleRemove.classList.add("button-disabled");
              buttonHandleRemove.classList.remove("button-active");
            }
            for (const sectionsHandleRemove of productSections) {
              sectionsHandleRemove.classList.add("section-hide");
              sectionsHandleRemove.classList.remove("section-active");
            }

            e.target.classList.remove("button-disabled");
            e.target.classList.add("button-active");

            productSectionsHandle.classList.remove("section-hide");
            productSectionsHandle.classList.add("section-active");
          }
        }
        ProductUniqueSky.updateTextButton();
        setTimeout(() => {
          ProductUniqueSky.focusFirstTabInput();
        }, 100)
      })
    }
  },

  formatSelect: function () {
    const designs = document.querySelectorAll(".product-right-design__design");

    for (const designsHandle of designs) {
      designsHandle.addEventListener("click", function () {
        if (this.classList.contains("design-selected")) return;

        for (const designsHandleRemove of designs) {
          designsHandleRemove.classList.remove("design-selected");
        }

        this.classList.add("design-selected");
      })
    }
  },

  changeFormat: function () {
    const designs = document.querySelectorAll(".product-right-design__design");
    const colors = document.querySelectorAll(".product-right-design__color");

    for (const designsHandle of designs) {
      designsHandle.addEventListener("click", function () {

        const formatSelected = this.dataset.format
        document.querySelector('#celestial-map canvas').classList.remove('canvas-coracao')

        if (window.outerWidth > 12) {
          console.log('if')
          if (formatSelected === 'triangulo') {
            Celestial.display({ width: 350 })
          } else if (formatSelected === 'coracao') {
            document.querySelector('#celestial-map canvas').classList.add('canvas-coracao')
            Celestial.display({ width: 400 })
          } else if (formatSelected === 'olho') {
            Celestial.display({ width: 320 })
          } else {
            Celestial.display({ width: 450 })
          }
        } else {
          console.log('else')
          if (formatSelected === 'olho') {
            Celestial.display({ width: 150 })
          } else if (formatSelected === 'triangulo') {
            console.log('triangulo')
            Celestial.display({ width: 130 })
          } else if (formatSelected === 'coracao') {
            document.querySelector('#celestial-map canvas').classList.add('canvas-coracao')
            Celestial.display({ width: 210 })
          } else if (formatSelected === 'trevo') {
            document.querySelector('#celestial-map canvas').classList.add('canvas-trevo')
            Celestial.display({ width: 260 })
          } else if (formatSelected === 'ying-yang') {
            Celestial.display({ width: 220 })
          } else if (formatSelected === 'lua') {
            Celestial.display({ width: 220 })
          } else if (formatSelected === 'garrafa') {
            Celestial.display({ width: 200 })
          } else {
            Celestial.display({ width: 250 })
          }
        }

        if (formatSelected === 'triangulo') {
          $("#celestial-map").addClass("map-down")
          $("#celestial-map").removeClass("map-down2")
          $("#celestial-map").removeClass("map-down3")
        } else if (formatSelected === 'olho') {
          $("#celestial-map").removeClass("map-down")
          $("#celestial-map").removeClass("map-down3")
          $("#celestial-map").addClass("map-down2")
        } else if (formatSelected === 'garrafa') {
          $("#celestial-map").removeClass("map-down")
          $("#celestial-map").addClass("map-down3")
        } else {
          $("#celestial-map").removeClass("map-down")
          $("#celestial-map").removeClass("map-down2")
          $("#celestial-map").removeClass("map-down3")
        }

        for (const colorsHandle of colors) {
          if (colorsHandle.classList.contains("color-selected")) {

            console.log('02')

            const colorSelected = colorsHandle.dataset.color;
            const colorSelectedPes = colorsHandle.dataset.colorPes;

            document.querySelector(".product-left__main").dataset.currentFormat = formatSelected;
            if (colorSelected == 'galaxia1' || colorSelected == 'galaxia2' || colorSelected == 'galaxia3') {
            }

            if (colorSelected == 'galaxia1' || colorSelected == 'galaxia2' || colorSelected == 'galaxia3') return;

            $(".image-mask").remove();
            if (colorSelected == 'galaxia1' || colorSelected == 'galaxia2' || colorSelected == 'galaxia3') return;

            if (formatSelected === 'pes' && colorSelectedPes) {
              console.log('here 01')
              $(".product-left__main").append(`<img class="image-mask ${formatSelected}" src="https://cdn.shopify.com/s/files/1/0629/6200/8308/t/4/assets/${formatSelected}-${colorSelectedPes}.png?v=1.3"/>`)
            } else {
              $(".product-left__main").append(`<img class="image-mask ${formatSelected}" src="https://cdn.shopify.com/s/files/1/0629/6200/8308/t/4/assets/${formatSelected}-${colorSelected}.png?v=1.3"/>`)
            }
          }
        }



      })
    }

  },

  colorSelect: function () {
    const colors = document.querySelectorAll(".product-right-design__color");

    for (const colorsHandle of colors) {
      colorsHandle.addEventListener("click", function () {
        console.log('click')
        const formatSelected = document.querySelector('.design-selected').dataset.format;
        console.log(formatSelected);
        document.querySelector(".product-left__main").dataset.currentFormat = formatSelected;
        console.log(document.querySelector(".product-left__main").dataset.currentFormat)
        if (this.classList.contains("color-selected")) return;

        for (const colorsHandleRemove of colors) {
          colorsHandleRemove.classList.remove("color-selected");
        }

        this.classList.add("color-selected");
      })
    }
  },

  changeMaskAndBgColor: function () {
    const designs = document.querySelectorAll(".product-right-design__design");
    const colors = document.querySelectorAll(".product-right-design__color");

    for (const colorsHandle of colors) {
      colorsHandle.addEventListener("click", function () {

        const dataSet = colorsHandle.dataset
        const colorSelected = colorsHandle.dataset.color
        const colorSelectedPes = colorsHandle.dataset.colorPes;

        document.querySelector(".product-left__main").dataset.currentFormat = '';
        if (dataSet.color === "preto") {
          document.querySelector(".product-left__main").classList.remove("galaxia1")
          document.querySelector(".product-left__main").classList.remove("galaxia2")
          document.querySelector(".product-left__main").classList.remove("galaxia3")
          document.querySelector(".product-left__main").style.backgroundColor = `#161616`
        } else if (dataSet.color === "branco") {
          document.querySelector(".product-left__main").classList.remove("galaxia1")
          document.querySelector(".product-left__main").classList.remove("galaxia2")
          document.querySelector(".product-left__main").classList.remove("galaxia3")
          document.querySelector(".product-left__main").style.backgroundColor = `white`
        } else if (dataSet.color === "galaxia1") {
          document.querySelector(".product-left__main").classList.remove("galaxia2")
          document.querySelector(".product-left__main").classList.remove("galaxia3")
          document.querySelector(".product-left__main").classList.add("galaxia1")
          document.querySelector(".product-left__main").style.backgroundColor = `#161616`;
        } else if (dataSet.color === "galaxia2") {
          document.querySelector(".product-left__main").classList.remove("galaxia1")
          document.querySelector(".product-left__main").classList.remove("galaxia3")
          document.querySelector(".product-left__main").classList.add("galaxia2")
          document.querySelector(".product-left__main").style.backgroundColor = `#161616`
        } else if (dataSet.color === "galaxia3") {
          document.querySelector(".product-left__main").classList.remove("galaxia1")
          document.querySelector(".product-left__main").classList.remove("galaxia2")
          document.querySelector(".product-left__main").classList.add("galaxia3")
          document.querySelector(".product-left__main").style.backgroundColor = `#161616`
        } else if (dataSet.color != "galaxia1" && dataSet.color != "galaxia2" && dataSet.color != "galaxia3") {
          document.querySelector(".product-left__main").classList.remove("galaxia1")
          document.querySelector(".product-left__main").classList.remove("galaxia2")
          document.querySelector(".product-left__main").classList.remove("galaxia3")
          document.querySelector(".product-left__main").style.backgroundColor = `${dataSet.bg}`
        }


        for (const designsHandle of designs) {
          if (designsHandle.classList.contains("design-selected")) {
            const formatSelected = designsHandle.dataset.format;

            if (colorSelected == 'galaxia1' || colorSelected == 'galaxia2' || colorSelected == 'galaxia3') {
              document.querySelector(".product-left__main").dataset.currentFormat = formatSelected;
            }

            $(".image-mask").remove();
            if (colorSelected == 'galaxia1' || colorSelected == 'galaxia2' || colorSelected == 'galaxia3') return;

            if (formatSelected === 'pes' && colorSelectedPes) {
              console.log('here 02')
              $(".product-left__main").append(`<img class="image-mask ${formatSelected}" src="https://cdn.shopify.com/s/files/1/0629/6200/8308/t/4/assets/${formatSelected}-${colorSelectedPes}.png?v=1.3"/>`)
            } else {
              $(".product-left__main").append(`<img class="image-mask ${formatSelected}" src="https://cdn.shopify.com/s/files/1/0629/6200/8308/t/4/assets/${formatSelected}-${colorSelected}.png?v=1.3"/>`)
            }

          }
        }
        const formatSelectedUpdated = document.querySelector('.design-selected').dataset.format;
        document.querySelector(".product-left__main").dataset.currentFormat = formatSelectedUpdated;
      })
    }
  },

  changeMapColor: function () {
    const skyColors = document.querySelectorAll(".product-right-design__color");

    skyColors.forEach(element => {
      element.addEventListener("click", function () {
        const color = element.dataset.cl;
        const background = element.dataset.bg;

        Celestial.display({
          background: {
            fill: background,
            opacity: 1,
            stroke: color,
            width: 1.5
          },
          constellations: {
            lineStyle: { stroke: color, width: 1, opacity: 0.6 }
          },
          stars: {
            style: { fill: color, opacity: 1 }
          }
        })
      })
    });
  },

  sizeSelect: function () {
    const sizes = document.querySelectorAll(".product-right-design__size");

    for (const sizesHandle of sizes) {
      sizesHandle.addEventListener("click", function () {
        if (this.classList.contains("size-selected")) return;

        for (const sizesHandle of sizes) {
          sizesHandle.classList.remove("size-selected");
        }

        this.classList.add("size-selected");
      })
    }
  },

  monthName: function (month) {
    if (!month) return '';
    month = month.replace(/^0+/, '');

    const months = [
      '',
      'janeiro',
      'fevereiro',
      'março',
      'abril',
      'maio',
      'junho',
      'julho',
      'agosto',
      'setembro',
      'outubro',
      'novembro',
      'dezembro',
    ]

    return months[month];
  },

  setDefaultText(isDefault) {
    const customMessage = document.querySelector("#custom-message");
    const locationInput = document.querySelector('.product-right-section__local');
    const textInputBottom = document.querySelector(".product-right-section__bottom-message");
    const textAreaBottom = document.querySelector(".product-left__text-bottom");
    const locationValue = locationInput.value?.split(',')[0];

    let date = document.querySelector("#date").value;
    let hour = document.querySelector("#hour").value;
    let minute = document.querySelector("#minute").value;

    const day = date.split('/')[0] || '';
    const month = ProductUniqueSky.monthName(date.split('/')[1]) || '';
    const year = date.split('/')[2] || '';


    if (isDefault) {
      customMessage.checked = true;

      console.log('checked')
      // textInputBottom.style.opacity = '0.5';
      // textInputBottom.style.pointerEvents = 'none';
      textInputBottom.value = `Estrelas sobre o céu de ${window.currentLocationShort} no dia ${day} de ${month} de ${year}`;
      // textInputBottom.dispatchEvent(new Event('keyup'));
    } else {
      console.log('none')
      textInputBottom.style.opacity = '1';
      textInputBottom.style.pointerEvents = 'all';
      textInputBottom.value = '';
      textInputBottom.dispatchEvent(new Event('keyup'));
    }

    if (textInputBottom.value.length < 22) {
      textAreaBottom.classList.remove("font-m");
      textAreaBottom.classList.remove("font-p");
      textAreaBottom.classList.add("font-g");
    } else if (textInputBottom.value.length >= 22 && textInputBottom.value.length < 44) {
      textAreaBottom.classList.remove("font-g");
      textAreaBottom.classList.remove("font-p");
      textAreaBottom.classList.add("font-m");
    } else if (textInputBottom.value.length >= 44) {
      textAreaBottom.classList.remove("font-g");
      textAreaBottom.classList.remove("font-m");
      textAreaBottom.classList.add("font-p");
    }
    textAreaBottom.textContent = textInputBottom.value;
  },


  liveInput: function () {
    const textInputTop = document.querySelector(".product-right-section__top-message");
    const textInputBottom = document.querySelector(".product-right-section__bottom-message");


    const textAreaTop = document.querySelector(".product-left__text-top");
    const textAreaBottom = document.querySelector(".product-left__text-bottom");
    const customMessage = document.querySelector("#custom-message");

    customMessage?.addEventListener('change', function () {
      if (this.checked) {
        ProductUniqueSky.setDefaultText(true);
      } else {
        ProductUniqueSky.setDefaultText();
      }
    })

    textInputTop.addEventListener("keyup", function () {
      textAreaTop.textContent = this.value;

      if (this.value.length < 22) {
        textAreaTop.classList.remove("font-m");
        textAreaTop.classList.remove("font-p");
        textAreaTop.classList.add("font-g");
      } else if (this.value.length >= 22 && this.value.length < 44) {
        textAreaTop.classList.remove("font-g");
        textAreaTop.classList.remove("font-p");
        textAreaTop.classList.add("font-m");
      } else if (this.value.length >= 44) {
        textAreaTop.classList.remove("font-g");
        textAreaTop.classList.remove("font-m");
        textAreaTop.classList.add("font-p");
      }
    });

    textInputBottom.addEventListener("keyup", function () {

      textAreaBottom.textContent = this.value;

      if (this.value.length < 22) {
        textAreaBottom.classList.remove("font-m");
        textAreaBottom.classList.remove("font-p");
        textAreaBottom.classList.add("font-g");
      } else if (this.value.length >= 22 && this.value.length < 44) {
        textAreaBottom.classList.remove("font-g");
        textAreaBottom.classList.remove("font-p");
        textAreaBottom.classList.add("font-m");
      } else if (this.value.length >= 44) {
        textAreaBottom.classList.remove("font-g");
        textAreaBottom.classList.remove("font-m");
        textAreaBottom.classList.add("font-p");
      }
    });
  },

  inputCounter: function () {
    const textInputFirstMessage = document.querySelector(".product-right-section__top-message");
    const textInputSecondMessage = document.querySelector(".product-right-section__bottom-message");
    const messageCounter = document.querySelector(".product-right-section__counter-1");
    const localCounter = document.querySelector(".product-right-section__counter-2");

    textInputFirstMessage.addEventListener("keyup", function () {
      messageCounter.textContent = 66 - this.value.length;
    });

    textInputSecondMessage.addEventListener("keyup", function () {
      localCounter.textContent = 66 - this.value.length;
    });
  },

  changeTextColor: function () {
    const bgColor = document.querySelectorAll(".product-right-design__color");
    const textTop = document.querySelector(".product-left__text-top");
    const textBottom = document.querySelector(".product-left__text-bottom");

    for (const bgColorHandle of bgColor) {
      bgColorHandle.addEventListener("click", function () {
        if (this.dataset.color == "branco") {
          textTop.style.color = "#161616";
          textBottom.style.color = "#161616";
        } else {
          textTop.style.color = "#fff";
          textBottom.style.color = "#fff";
        }
      });
    }
  },

  getDataToMountClientMap: function () {
    let date;
    let hour;
    let minute;
    let latlng;
    // const axios = require('axios');
    const apiKey = 'AIzaSyAF_3CAyAVqhWgtL0aqQEGmVs7X1_ycX6U';
    const url = 'https://maps.googleapis.com/maps/api/geocode/json';
    const location = document.querySelector(".product-right-section__local");
    const locationButton = document.querySelector(".product-right-section__row-search");

    const textInputBottom = document.querySelector(".product-right-section__bottom-message");

    locationButton.addEventListener("click", function () {
      date = document.querySelector("#date").value;
      hour = document.querySelector("#hour").value;
      minute = document.querySelector("#minute").value;

      axios.get(url, {
        params: {
          address: location.value || 'Curitiba',
          key: apiKey
        }
      }).then(response => {
        console.log(response)
        console.log(response.data.results[0].geometry.location)
        latlng = response.data.results[0].geometry.location
        window.currentLocation = location.value;
        window.currentLocationShort = response.data.results[0].formatted_address.split(',')[0];

        textInputBottom.value = location.value;
        // textInputBottom.dispatchEvent(new Event('keyup'));

        ProductUniqueSky.mountClientMap(latlng, date, hour, minute)

        window.locationProceed = true;
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
      })
    })
  },

  placeInputAutocomplete: function () {
    let autocomplete;
    const location = '.product-right-section__local';
    const script = document.createElement('script');
    const apiKey = 'AIzaSyAF_3CAyAVqhWgtL0aqQEGmVs7X1_ycX6U';

    if (!window.scriptLoaded) {

      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=initAutoComplete&libraries=places`;
      script.async = true;
      window.scriptLoaded = true;
    }

    window.initAutoComplete = function () {
      autocomplete = new google.maps.places.Autocomplete(
        document.querySelector(location), {
        types: ['establishment', 'geocode']
      }
      )
      autocomplete.addListener('place_changed', onPlaceChanged);
    }

    function onPlaceChanged() {
      const place = autocomplete.getPlace();
      const updateTrigger = document.querySelector('.product-right-section__row-search');

      if (!place.geometry) {
        document.querySelector(location).placeholder = 'Procure o local'
      } else {
        // document.querySelector(location).innerHTML = place.name;
        updateTrigger.click();
      }
      setTimeout(function () {
        ProductUniqueSky.setDefaultText(true);
      }, 500)
    }

    document.head.appendChild(script);
  },

  mountInitialMap: function () {
    const date = new Date()
    const completeDate = `${date.getMonth() + 1 > 9 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`} ${date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`} ${date.getFullYear()}`
    document.querySelector(".product-right-section__local").value = ""
    // document.querySelector(".product-right-section__date").value = completeDate.split(" ").join("/")
    document.querySelector(".product-right-section__hour").value = date.getHours() > 9 ? date.getHours() : `0${date.getHours()}`
    document.querySelector(".product-right-section__minute").value = date.getMinutes() > 9 ? date.getMinutes() : `0${date.getMinutes()}`

    Celestial.display({
      width: window.outerWidth > 1200 ? 450 : 450,
      geopos: [-25.4284, -49.2733],
      location: true,
      controls: false,
      interactive: false,
      projection: "airy",
      datapath: "https://ofrohn.github.io/data/",
      planets: { show: false },
      dsos: { show: false },
      constellations: {
        names: false,
        lineStyle: { stroke: "#ccc", width: 1, opacity: 0.6 }
      },
      stars: {
        colors: false,
        designation: false
      },
      lines: {
        equatorial: { show: false },
        graticule: { show: false },
        equatorial: { show: false },
        ecliptic: { show: false },
        galactic: { show: false },
        supergalactic: { show: false }
      },
    });
  },


  mountClientMap: function (latlng, date, hour, minute) {
    const { lat, lng } = latlng
    const day = date.split('/')[0]
    const month = date.split('/')[1]
    const year = date.split('/')[2]

    Celestial.skyview({
      "date": new Date(Date.UTC(year, month, day, hour, minute)),
      "location": [lat.toFixed(4), lng.toFixed(4)],
      "timezone": new Date(Date.UTC(year, month, day, hour, minute)).getTimezoneOffset()
    });
  },

  updateProductPrice: function () {
    skuJson_0.skus.forEach(skuItem => {
      let skuSize = skuItem.skuname.toLocaleLowerCase();
      let currentProductSizeElement = document.querySelector(`[data-size="${skuSize}"]`);
      let skuPricePromo = skuItem.listPriceFormated !== skuItem.bestPriceFormated;
      console.log(skuItem);
      console.log(skuItem.available);

      if (skuItem.available) {
        currentProductSizeElement.querySelector('.product-right-design__size-price').innerHTML = `${skuPricePromo ? '<small>' + skuItem.listPriceFormated + '</small>' : ''}${skuItem.bestPriceFormated}`;
      } else {
        currentProductSizeElement.querySelector('.product-right-design__size-price').innerHTML = `Esgotado`;
        currentProductSizeElement.classList.add('disabled');
      }
    })

    if (document.querySelector('.size-selected').classList.contains('disabled')) {
      document.querySelector('.size-selected').classList.remove('size-selected');
      document.querySelector('.product-right-design__size-wrapper .product-right-design__size:not(.disabled)').classList.add('size-selected');
    }

  },

  hideBuyButtonOnFocus: function () {
    const mqMax = window.matchMedia("(max-width: 1023px)").matches;
    const inputElements = document.querySelectorAll('.product > form input');
    const buyButton = document.querySelector('.product-right__button');
    if (!mqMax) return;
    inputElements.forEach(item => {
      item.addEventListener('focus', () => {
        buyButton.classList.add('hidden');
      })
      item.addEventListener('blur', () => {
        buyButton.classList.remove('hidden');
      })
    })
  },

  buyProduct: function () {
    const mqMax = window.matchMedia("(max-width: 1023px)").matches;
    const buyButton = document.querySelector(".product-right__button");

    buyButton.addEventListener("click", function () {
      const size = document.querySelector(".size-selected").dataset.size;
      let stepOneActive = document.querySelector('#sec-1.button-active');
      let stepTwoActive = document.querySelector('#sec-2.button-active');

      if (stepOneActive) {
        if (mqMax) {
          if (document.querySelector('.-focus')?.dataset.last) {
            document.querySelector('#sec-2').click()
          }
          ProductUniqueSky.updateFocusElement();
          ProductUniqueSky.updateTextButton();
          return;
        } else {
          document.querySelector('#sec-2').click()
          return;
        }
      }

      if (stepTwoActive) {
        if (mqMax) {
          if (document.querySelector('.-focus')?.dataset.last) {
            document.querySelector('#sec-3').click()
          }
          ProductUniqueSky.updateFocusElement();
          ProductUniqueSky.updateTextButton();
          return;
        } else {
          document.querySelector('#sec-3').click()
          return;
        }
      }

      if (size === 'a2') {
        ProductUniqueSky.addProductAndGoToCheckout(258)//alterar o parametro para o sku correto
      } else if (size === 'a3') {
        ProductUniqueSky.addProductAndGoToCheckout(259)
      } else if (size === 'a4') {
        ProductUniqueSky.addProductAndGoToCheckout(260)
      }
    })

  },


  addProductAndGoToCheckout: function (sku) {
    let item = {
      id: sku,
      quantity: 1,
      seller: '1'
    };

    vtexjs.checkout.addToCart([item], null, 1)
      .done(orderForm => {

        let itemIndex = orderForm.items.length - 1;
        let attachmentName = "UniqueSky";

        const colorSelected = document.querySelector('.color-selected').dataset.color;
        const colorSelectedPes = document.querySelector('.color-selected').dataset.colorPes;

        let date = document.querySelector("#date").value;
        let hour = document.querySelector("#hour").value;
        let minute = document.querySelector("#minute").value;
        let locationValue = document.querySelector('.pac-target-input').value;

        const day = date.split('/')[0]
        const month = date.split('/')[1]
        const year = date.split('/')[2]

        let firstMessage = document.querySelector('.product-right-section__top-message').value;
        let secondMessage = document.querySelector('.product-right-section__bottom-message').value;
        let format = document.querySelector('.design-selected').dataset.format;
        let dateHour = `${day}/${month}/${year} - ${hour}:${minute}`;
        let mapColor;

        if (format === 'pes' && colorSelectedPes) {
          mapColor = colorSelectedPes;
        } else {
          mapColor = colorSelected;
        }



        let content = {
          data_horario: dateHour,
          local: locationValue,
          primeira_mensagem: firstMessage,
          segunda_mensagem: secondMessage,
          formato: format,
          cor_do_ceu: mapColor,
          svg: ''
        };

        if (firstMessage !== content.primeira_mensagem || secondMessage !== content.segunda_mensagem) {
          alert('500 server error; try again');
          return;
        }

        exportSVG(item.id, attachmentName, content, orderForm)
      });
  },
}

export default ProductUniqueSky;